/* eslint-disable */
export const playerDrag = {
    update: function (el, binding, vNode) {
        if (!binding.value) {
            el.onmousedown = null;
            el.onmouseup = null;
            window.onmousemove = null;
            return
        }
        let x = 0;
        let y = 0;
        let l = 0;
        let t = 0;
        let isDown = false;
        el.onmousedown = (e) => {
            //获取x坐标和y坐标
            x = e.clientX;
            y = e.clientY;
            //获取左部和顶部的偏移量
            l = el.offsetLeft;
            t = el.offsetTop;
            //开关打开
            isDown = true;
        }
        // 鼠标抬起事件
        el.onmouseup = () => {
            //开关关闭
            isDown = false;
        }
        //鼠标移动事件
        window.onmousemove = (e) => {
            if (isDown === false) {
                return;
            }
            //获取x和y
            let nx = e.clientX;
            let ny = e.clientY;
            //计算移动后的左偏移量和顶部的偏移量
            let nl = nx - (x - l);
            let nt = ny - (y - t);
            const maxSpace = 100; // 拖拽到屏幕外保留maxSpace的可操作区 不可将组件完全拖出去
            if (window.innerWidth - nl <= maxSpace) {
                nl = window.innerWidth - maxSpace
            }
            if (nl < 0) {
                // 已经拖拽到左侧屏幕外了
                if (el.offsetWidth - Math.abs(nl) <= maxSpace) {
                    nl = -(el.offsetWidth - maxSpace)
                }
            }

            if (window.innerHeight - nt <= maxSpace) {
                nt = window.innerHeight - maxSpace
            }
            if (nt < 0) {
                // 已经拖拽到左侧屏幕外了
                if (el.innerHeight - Math.abs(nt) <= maxSpace) {
                    nt = -(el.innerHeight - maxSpace)
                }
            }
            el.style.left = nl + 'px';
            el.style.top = nt + 'px';
        }

    }
};
